import Modal from 'core/components/dialogs/Modal'
import useWallet from 'core/hooks/useWallet'
import { useSettings } from 'core/hooks/useSettings'
import { useMemo } from 'react'
import Icon from 'core/components/icons/Icon'
import Tooltip from 'core/components/dialogs/Tooltip'
import FundingMethodItem from './FundingMethodItem'
import Button from 'core/components/buttons/Button'

const FundingModal = () => {
  const { hasWallet } = useWallet()
  const {
    data: {
      featureFlags: { ENABLE_PAYMENTS_M3 },
      fundingModal: { show }
    }
  } = useSettings()

  const title = useMemo(() => {
    return 'Deposit money'
  }, [])

  const selectedPayPeriods = [1, 2]

  const amountBrief = useMemo(() => {
    return (
      <div className="text-dark-4">
        <span>June 1-16, 2025 • Fixed</span>
        {selectedPayPeriods.length > 0 && (
          <Tooltip
            dark
            content={
              <div>
                <div>Selected pay periods:</div>
                <ul className="list-disc pl-7">
                  {selectedPayPeriods.map((payPeriod) => (
                    <li key={payPeriod}>June 1-16, 2025, Fixed: $10,000.00</li>
                  ))}
                </ul>
              </div>
            }
          >
            <span className="ml-1 text-primary cursor-pointer">
              +{selectedPayPeriods.length}
            </span>
          </Tooltip>
        )}
      </div>
    )
  }, [])

  if (ENABLE_PAYMENTS_M3 === false || !hasWallet) return null

  return (
    <Modal show={show} title={title}>
      <div className="rounded-md bg-dark-8 px-5 py-10 flex justify-between items-center mb-5">
        <div className="heading-2 text-dark-4">Amount</div>
        <div className="flex flex-col items-end">
          <div className="flex items-center gap-5">
            <div className="text-[36px] font-bold">$ 10,000.00</div>
            <Icon
              name="edit"
              color="text-primary"
              size={20}
              className="cursor-pointer"
            />
          </div>
          {amountBrief}
        </div>
      </div>
      <div className="mb-20">
        <div className="mb-3 subtitle-1 font-semibold">Funding Method</div>
        <div className="flex flex-col gap-4">
          <FundingMethodItem
            title="ACH Debit"
            info="May miss July 28th scheduled pay date"
            showCheckIcon={false}
            isSelected={true}
            onClick={console.log}
          />
          <FundingMethodItem
            title="ACH Credit"
            info="On time for July 28th scheduled pay date"
            showCheckIcon={true}
            onClick={console.log}
          />
          <FundingMethodItem
            title="Wire transfer"
            info="On time for July 28th scheduled pay date"
            showCheckIcon={true}
            onClick={console.log}
          />
        </div>
      </div>
      <div>
        <Button variant="primary" disabled={true} className="w-full h-[48px]">
          Initiate funding
        </Button>
      </div>
    </Modal>
  )
}

export default FundingModal
